import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fieldset, Input, UniversalSelect } from '@feathr/components';
import { flattenError } from '@feathr/hooks';
import { useFlags } from '@feathr/report_components';

import type { IPersonFieldOption } from '../GroupExportModal.utils';
import type { IPersonTabState } from './PersonTab.hooks';

export interface IPersonTabProps {
  state: IPersonTabState;
}

function PersonTab({ state }: Readonly<IPersonTabProps>): JSX.Element {
  const { t } = useTranslation();
  const { showEmailActivityExport } = useFlags();

  const {
    exportName,
    exportNameHadFocus,
    email,
    emailHadFocus,
    isCustomFieldsPending,
    personFieldOptions,
    selectedFieldOptions,
    exportNameError,
    emailError,
    fieldsError,
    handleChangeExportName,
    handleExportNameBlur,
    handleChangeEmail,
    handleEmailBlur,
    handleSelectFields,
  } = state;

  return (
    <Fieldset>
      {showEmailActivityExport && (
        <Input
          isClearable={true}
          label={t('Export name')}
          onBlur={handleExportNameBlur}
          onChange={handleChangeExportName}
          type={'text'}
          validationError={exportNameHadFocus ? flattenError(exportNameError) : undefined}
          value={exportName}
        />
      )}
      <UniversalSelect<IPersonFieldOption>
        isLoading={isCustomFieldsPending}
        isMulti={true}
        label={t('Fields')}
        name={'person-fields'}
        onSelectMulti={handleSelectFields}
        options={personFieldOptions}
        validationError={flattenError(fieldsError)}
        value={selectedFieldOptions}
      />
      <Input
        helpText={t('If you want to send the report to a different email address.')}
        isClearable={true}
        label={t('Email address')}
        onBlur={handleEmailBlur}
        onChange={handleChangeEmail}
        type={'text'}
        validationError={emailHadFocus ? flattenError(emailError) : undefined}
        value={email}
      />
    </Fieldset>
  );
}

export default PersonTab;
